// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1t_Zq","bigColWidth":"Table_bigColWidth__15RVT","biggerColWidth":"Table_biggerColWidth__2_niG","row":"Table_row__3qW68","col":"Table_col__1_pyn"};